export namespace Brands {
  export enum Pages {
    BRAND = 'brand_portal',
    DESIGN = 'design',
  }
  export interface Design {
    id?: number | null,
    name: string | null,
  }
  export interface Brand {
    mission: {
      title: string | null;
      content: string | null;
      image_path: string | null;
    }[],
    style: {
      id?: number | null,
      content: string | null,
      video_path: string,
      preview_video_image_path: string | null,
      images: {
        id?: number | null;
        src: string | null;
      }[],
      type: {
        id?: number | null;
        name: string | null;
        slug: string | null;
      };
    }
  }

  export interface DesingPageList {
    id?: number | null,
    name: string | null,
  }

  export interface DesingBlock {
    block_content: string | null,
    title: string | null,
    images: {
      image_path: string | null,
      image_title: string | null,
      file_path: string | null,
    }[],
  }

  export interface PartnerShip {
    id?: number | null;
    title: string | null;
    url: string | null;
  }
}
